const vacancyRules = {
  position: [
    { required: true, message: 'Пожалуйста, введите должность', trigger: 'change' }
  ],
  comitteeId: [
    { required: true, message: 'Пожалуйста, введите орган исполнительной власти', trigger: 'change', type: 'number'}
  ],
  contacts: [
    { required: true, message: 'Пожалуйста, введите контактную информацию', trigger: 'change' }
  ],
  place: [
    { required: true, message: 'Пожалуйста, введите место проведения', trigger: 'change' }
  ],
  dateOfContestPreliminary: [
    { required: true, validator: (rule, value, callback) => {
        if(value)
          return callback();
        else
          return callback(new Error('Пожалуйста, введите предварительную дату проведения'));
      }, trigger: 'change'}
  ],
  dateDocumentsAppliedFrom: []
};

export default {
  getVacancyRules() {
    return vacancyRules;
  }
}



// WEBPACK FOOTER //
// ./src/api/rules/vacancy.js